<template>
    <v-container fluid>
         <div v-if="!loading">  
            <v-row justify="end">
                <information :text="`${text[locale.split('-')[0]]}`" />
            </v-row>
			<!--table head-->
			<v-divider color="black" />
            <v-row class="subtitle-2 my-1" no-gutters>
                <v-col class="text-left">{{'Trademark' | localize}} / {{'Segment' | localize}}</v-col>
                <v-divider vertical color="black" />
                <v-col v-for="(segment, i) in segments" :key="i" class="text-center">
                    {{ segment.name }}
                </v-col>
            </v-row>
            <v-divider color="black" />
            <!--loyalty tab-->
            <div v-if="loyalty.length > 0">
                
                <div v-for="trademark in trademarks" :key="trademark.i">
                    <v-row class="body-2" no-gutters>
                        <v-col class="text-left my-1">{{ trademark.name }}</v-col>
                        <v-divider vertical />
                        <v-col v-for="(segment, i) in segments" :key="i" class="text-center my-1">
                            {{ getLoyalty(segment.id, trademark.id) }}%
                        </v-col>
                    </v-row>
                    <v-divider />
                </div>
            </div>
            <v-row v-else class="mt-8 px-4" justify="center">
                You haven't loyalty yet!
            </v-row>
        </div>
        <!--!loading-->
        <v-row v-else justify="center" class="mt-12">
            <loader />
        </v-row>
    </v-container>
</template>
<script>
import { roundNumber } from '../../../functions/common';
import Information from '../../../layouts/Information.vue';
import Loader from '../../../layouts/Loader.vue';
export default {
    name: 'BrandLoyalty',
    data() {
        return {
            text: {
                en: 'The loyalty assessment shows the percentage of consumers in each market segment who express a preference for a specific product brand.',
                ro: 'Evaluarea loialității indică procentul de consumatori din fiecare segment de piață care manifestă o preferință pentru o anumită marcă de produs.',
                ru: 'Оценка лояльности показывает долю потребителей в каждом сегменте рынка, которые отдают предпочтение конкретной торговой марке.'
            }
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading;
        },
        locale() {
            return this.$store.getters.locale;
        },
        game() {
			return this.$store.getters.game;
		},
        loyalty() {
            return this.$store.getters.loyalty;
        },
        segments() {
            let res = [];
            if (this.loyalty.length > 0) {
              this.loyalty.map((item) => {
                const inArr = res.find((it) => it.id == item.segment.id)
                if (!inArr) {
                    res.push({ id: item.segment.id,
                        name: item.segment.name });
                }
                });  
            }
            return res;
        },
        trademarks() {
            let res = [];
            if (this.loyalty.length > 0) {
              this.loyalty.map((item) => {
                const inArr = res.find((it) => it.id == item.trademark.id)
                if (!inArr) {
                    res.push({ id: item.trademark.id,
                        name: item.trademark.name });
                }
                });  
            }
            return res;
        }
    },
    methods: {
        getLoyalty(segmentId, trademarkId) {
            let line = this.loyalty.find((item) => item.segmentId == segmentId && item.trademarkId == trademarkId);
            let res = line ? roundNumber(line.loyalty * 100, 2) : 0;
            return res;
        }
    },
    components: { Loader, Information },
    async created() {

		if (this.loyalty?.length < 1 && this.game  && Number(this.game.round) > 0) {

			const params = {
				gameId: this.game.id,
				round: this.game.round - 1,
			}
			try {
				//get last round loyalty
				await this.$store.dispatch('fetchLoyalty', params);
			}
			catch (error) {
				await this.$store.dispatch('setError', error.message);
			}
		}
	}
}
</script>